import { forwardRef } from 'react';
import type {
  ForwardedRef,
  ReactElement,
} from 'react';

import styled from 'styled-components';

import type {
  DropdownRenderProps,
} from '../Dropdown';

export const StyledButton = styled.button<{
  isDropdownOpen: boolean;
  disabled: boolean;
}>(({
  isDropdownOpen,
  disabled,

  theme: {
    colors,
  },
}) => ({
  display: 'flex',
  margin: 0,
  padding: 0,
  border: 'none',

  color: disabled
    ? colors.NEUTRAL_INACTIVE
    : isDropdownOpen
      ? colors.ACTION_PRESSED
      : colors.ACTION_DEFAULT,

  cursor: disabled ? 'default' : 'pointer',
  outline: 'none',
  backgroundColor: 'transparent',
  fontSize: 18,

  ':hover': disabled ? undefined : {
    color: colors.ACTION_HOVER,
  },

  ':active': disabled ? undefined : {
    color: colors.ACTION_PRESSED,
  },
}));

const StyledSVG = styled.svg({
  verticalAlign: 'bottom',
});

export type DropdownReferenceProps = DropdownRenderProps & {
  disabled?: boolean;
};

function DropdownReferenceInner(
  {
    isDropdownOpen,
    disabled = false,
    onClick,
  }: DropdownReferenceProps,
  ref: ForwardedRef<HTMLButtonElement>,
): ReactElement {
  return (
    <StyledButton
      type="button"
      isDropdownOpen={isDropdownOpen}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
    >
      <StyledSVG
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0007 6.66665C10.9173 6.66665 11.6673 5.91665 11.6673 4.99998C11.6673 4.08331 10.9173 3.33331 10.0007 3.33331C9.08398 3.33331 8.33398 4.08331 8.33398 4.99998C8.33398 5.91665 9.08398 6.66665 10.0007 6.66665ZM10.0007 8.33331C9.08398 8.33331 8.33398 9.08331 8.33398 9.99998C8.33398 10.9166 9.08398 11.6666 10.0007 11.6666C10.9173 11.6666 11.6673 10.9166 11.6673 9.99998C11.6673 9.08331 10.9173 8.33331 10.0007 8.33331ZM8.33398 15C8.33398 14.0833 9.08398 13.3333 10.0007 13.3333C10.9173 13.3333 11.6673 14.0833 11.6673 15C11.6673 15.9166 10.9173 16.6666 10.0007 16.6666C9.08398 16.6666 8.33398 15.9166 8.33398 15Z"
        />
      </StyledSVG>
    </StyledButton>
  );
}

export const DropdownReference = forwardRef(DropdownReferenceInner);
